module.exports = __webpack_public_path__ + "static/media/speaker_CIBSE_KevinKelly.03465865.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_CIBSE_KevinKelly.jpg
// module id = 255
// module chunks = 0